import { Controller } from "@hotwired/stimulus"

// Flips the .game-card inside the element (admin previews; participants get the React GameCard in stage 3).
export default class extends Controller {
  flip() {
    const card = this.element.querySelector(".game-card")
    if (!card) return

    const flipped = card.classList.toggle("is-flipped")
    card.querySelector(".game-card__back").setAttribute("aria-hidden", String(flipped))
    card.querySelector(".game-card__face").setAttribute("aria-hidden", String(!flipped))
  }
}
